import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const Callback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (code) {
      navigate(`/select-account?code=${encodeURIComponent(code)}`, { replace: true });
      return;
    } else {
      navigate("/signin", { replace: true });
    }
  }, [location.search, navigate]);

  return null;
};
